import PropTypes from 'prop-types';

const propType = {
  link: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default { propType };
